import styled from 'styled-components';

import {
  colors,
  typography,
} from '../../theme';

import {
  TagBox,
} from '../../elements';

export const Wrapper = styled.div`
  height: 0;
  overflow: visible;
  position: absolute;
  /* transition: transform .3s ease-in-out; */
  width: 0;
`;

export const Box = TagBox.withComponent('a');

export const Link = Box.extend`
  ${typography.BODY__SMALL}
  background: ${colors.GREY__WHITE};
  color: ${colors.BLACK};
  text-decoration: none;
  transform: translate3d(-50%, -50%, 0);
  white-space: nowrap;
  display: inline-block;
  ${typography.TAGBOX}
  transition: background .2s linear;

  &:hover {
    background: ${colors.WHITE};
  }
`;



// WEBPACK FOOTER //
// ./src/components/TrendingSearchTerm/style.js